"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNICODE_RANGES = void 0;
const burmese_1 = require("./burmese");
const cjk_1 = require("./cjk");
const javanese_1 = require("./javanese");
const khmer_1 = require("./khmer");
const lao_1 = require("./lao");
const thai_1 = require("./thai");
const vai_1 = require("./vai");
exports.UNICODE_RANGES = [
    ...thai_1.THAI_UNICODE_RANGE,
    ...lao_1.LAO_UNICODE_RANGE,
    ...burmese_1.BURMESE_UNICODE_RANGE,
    ...khmer_1.KHMER_UNICODE_RANGE,
    ...javanese_1.JAVANESE_UNICODE_RANGE,
    ...vai_1.VAI_UNICODE_RANGE,
    ...cjk_1.CJK_UNICODE_RANGES,
];
